export enum UseCase {
  Visualize = 'visualize',
  Select = 'select',
}
